export const TOKEN_HEADER_TYPE = 'authorization'
export const TOKEN_PREFIX = 'Bearer'